const paymentSummaryIdEnums = {
    registrationAmount: 'registrationAmount',
    subscriptionAmount: 'subscriptionAmount',
    subscriptionDuration: 'subscriptionDuration',
    totalAmount: 'totalAmount',
}
